module.exports = __webpack_public_path__ + "static/media/edecan.b4daa0d9.png";